
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
@keyframes splide-loading{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.splide__track--draggable{-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}.splide__track--fade>.splide__list>.splide__slide{margin:0!important;opacity:0;z-index:0}.splide__track--fade>.splide__list>.splide__slide.is-active{opacity:1;z-index:1}.splide--rtl{direction:rtl}.splide__track--ttb>.splide__list{display:block}.splide__container{box-sizing:border-box;position:relative}.splide__list{backface-visibility:hidden;display:flex;height:100%;margin:0!important;padding:0!important}.splide.is-initialized:not(.is-active) .splide__list{display:block}.splide__pagination{align-items:center;display:flex;flex-wrap:wrap;justify-content:center;margin:0;pointer-events:none}.splide__pagination li{display:inline-block;line-height:1;list-style-type:none;margin:0;pointer-events:auto}.splide:not(.is-overflow) .splide__pagination{display:none}.splide__progress__bar{width:0}.splide{position:relative;visibility:hidden}.splide.is-initialized,.splide.is-rendered{visibility:visible}.splide__slide{backface-visibility:hidden;box-sizing:border-box;flex-shrink:0;list-style-type:none!important;margin:0;position:relative}.splide__slide img{vertical-align:bottom}.splide__spinner{animation:splide-loading 1s linear infinite;border:2px solid #999;border-left-color:transparent;border-radius:50%;bottom:0;contain:strict;display:inline-block;height:20px;left:0;margin:auto;position:absolute;right:0;top:0;width:20px}.splide__sr{clip:rect(0 0 0 0);border:0;height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.splide__toggle.is-active .splide__toggle__play,.splide__toggle__pause{display:none}.splide__toggle.is-active .splide__toggle__pause{display:inline}.splide__track{overflow:hidden;position:relative;z-index:0}.carousel{
  position:relative;
  padding-bottom:4rem;
}@media (min-width: 1024px){.carousel{
    padding-bottom:0;
    padding-top:3.75rem;
}
  }.carousel-inner{
  margin-left:auto;
}.splide:not(.is-overflow) .splide__counter,
  .splide:not(.is-overflow) .splide__arrows{
    display:none;
  }.splide__track{
  position:relative;
  margin-right:calc(57% - 50vw) !important;
  padding-left:var(--spacing-02) !important;
  padding-top:var(--spacing-02);
  padding-bottom:var(--spacing-02);
}.splide__wrapper::before,
.splide__wrapper::after{
  content:'';
  position:absolute;
  pointer-events:none;
  top:0;
  bottom:0;
  z-index:10;
  width:var(--spacing-24);
  transition-property:opacity;
  transition-timing-function:cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration:300ms;
  opacity:0;
}@media (min-width: 1920px){.splide__wrapper::after{
    right:calc(var(--x-padding) / -1);
    left:initial;
    background:linear-gradient(
      270deg,
      var(--sic-bg-color) 8.76%,
      rgba(255, 255, 255, 0) 100%
    )
}
  }@media (min-width: 2350px){.splide__wrapper::after{
    right:calc(
      (
          100vw - var(--container-max-content-width) -
            (var(--container-px-normal) * 2)
        ) / -2
    )
}
  }@media (min-width: 1920px){.splide__wrapper::before{
    background:linear-gradient(
      270deg,
      var(--sic-bg-color) 8.76%,
      rgba(255, 255, 255, 0) 100%
    );
    transform:rotate(180deg);
    left:0
}
  }:host([has-next]) .splide__wrapper::after{
  opacity:1;
}:host([slide-last]) .splide__wrapper::after{
  opacity:0;
}:host([slide-last]) .splide__wrapper::before{
  opacity:1;
}@media (min-width: 1380px){.splide__slide{
    width:calc(((100% + 2rem) / 3.5) - 2rem) !important
}
  }.splide__slide > *{
    box-sizing:border-box;
    display:block;
    height:100%;
  }.splide__slide.is-visible{
    visibility:visible;
  }.screen-reader-only{
  position:absolute;
  margin:-1px;
  height:1px;
  overflow:hidden;
  border-width:0px;
  padding:0;
  clip:rect(0, 0, 0, 0);
}.splide__arrows{
  display:flex;
  gap:20px;
  align-items:center;
  justify-content:center;
  position:absolute;
  bottom:calc(-1 * var(--spacing-03));
  left:0;
  right:0;
  z-index:40;
}@media (min-width: 1024px){.splide__arrows{
    bottom:initial;
    right:initial;
    top:0
}
  }.splide__arrow{
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:9999px;
  border-style:none;
  padding:0;
  background:transparent;
  height:48px;
  width:48px;

  --icon-color:#004ea8;
  --icon-contrast-color:white;
}.splide__arrow[disabled] svg{
  fill:var(--icon-color);
  opacity:0.5;
}.splide__arrow svg{
  border-radius:9999px;
  padding:0.5rem;

  fill:var(--icon-color);

  transition:fill 0.5s, border 0.5s, background-color 0.5s;
}.splide__arrow:not(:disabled):hover,
.splide__arrow:not(:disabled):focus,
.splide__arrow:not(:disabled):focus-within{
  box-shadow:var(--neutral-grayVeryDark) -1px 0px 6px;
}.splide__arrow:not(:disabled):hover svg,
.splide__arrow:not(:disabled):focus svg,
.splide__arrow:not(:disabled):focus-within svg{
  fill:var(--icon-contrast-color);
  background-color:var(--icon-color);
}.splide__arrow--prev svg{
  transform:rotate(180deg);
}.splide__arrow:hover{
  cursor:pointer;
}.splide__arrow:disabled{
  cursor:not-allowed;
}.splide__counter{
  position:absolute;
  bottom:22px;
  z-index:4;
  display:flex;
  flex-direction:row;
  gap:2.125rem;
  align-items:center;
  justify-content:center;
  width:100%;
  color:var(--color-primary-default);
  font-size:var(--fs-sm);
}@media (min-width: 1024px){.splide__counter{
    position:absolute;
    top:13px;
    right:0;
    left:initial;
    bottom:initial;
    height:initial;
    width:initial
}
  }.splide__counter span{
    height:34px;
  }.splide__counter .current-slide{
    display:flex;
    flex-direction:row;
    gap:0.75rem;
  }.splide__counter .current-slide--dash,
  .splide__counter .current-slide--lg,
  .splide__counter .current-slide--xl{
    display:none;
  }@media (min-width: 1024px){
    .splide__counter .current-slide--dash,
    .splide__counter .current-slide--lg{
      display:block;
    }
  }@media (min-width: 1380px){
    .splide__counter .current-slide--lg{
      display:none;
    }
    .splide__counter .current-slide--xl{
      display:block;
    }
  }.slide-count{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0, 0, 0, 0);white-space:nowrap;border-width:0}
`;